import type { IGameCategory } from '~/interfaces/dto/games/response';
import { globalKeys } from 'assets/data/global-keys';
import type { RouteLocationRaw } from 'vue-router';

interface IUseLaunchUrl {
  fromProvider: boolean;
  fromFavorites: boolean;
  fromGoldenCircle: boolean;
  fromDemoPlay: boolean;
  category: string;
  url: RouteLocationRaw;
}

export default function ({
  game,
  category,
  isFavourite,
  isSearch,
  launchAsDemoPlay,
  restore = false,
  query,
}: {
  game: IGameCategory;
  category?: string;
  isFavourite?: boolean;
  isSearch?: boolean;
  launchAsDemoPlay?: boolean;
  restore?: boolean;
  query?: Record<string, unknown>;
}): IUseLaunchUrl {
  const route = useRoute();
  const { categories } = game;
  const cats: string[] = Object.keys(categories || {});

  const fromProvider = route.path.includes('provider');
  const fromFavorites = isFavourite || route.path.includes('favorites');
  const fromGoldenCircle = route.path.includes('winners');
  const fromDemoPlay =
    route.path.includes(globalKeys.navigationKeys.demoPlayRoute) &&
    !launchAsDemoPlay;

  const computedCategory = computed(() =>
    category || launchAsDemoPlay
      ? globalKeys.navigationKeys.demoPlayRoute
      : !route.params.category
        ? cats?.[0]?.toLowerCase() || 'home'
        : (route.params.category as string),
  );

  return {
    fromProvider,
    fromFavorites,
    fromGoldenCircle,
    fromDemoPlay,
    category: computedCategory.value,
    url: {
      name: 'contentType-category-game',
      params: {
        contentType: route.params.contentType || 'home',
        category: computedCategory.value,
        game: game.alias,
      },
      query: {
        ...(fromProvider && {
          // provider
          pr: 'true',
          // game provider
          gpr: game.provider,
        }),
        ...(fromFavorites && { favorite: 'true' }),
        ...(fromGoldenCircle && { gc: 'true' }),
        ...(launchAsDemoPlay && { dp: 'true' }),
        ...(fromDemoPlay && { fdp: 'true' }),
        ...(isSearch && { sea: 'true' }),
        ...(restore && { res: 'true' }),
        ...(game.isPromoted && { pro: 'true' }),
        ...(game.exclusive && { excl: 'true' }),
        ...(game.isNew && { new: 'true' }),
        ...query,
      },
    },
  };
}
